export default __webpack_public_path__ + "static/media/icon-favorite.08180c40.svg";